import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=7ef8b1fc&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=7ef8b1fc&prod&lang=scss&scoped=true"
import style1 from "./Notification.vue?vue&type=style&index=1&id=7ef8b1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef8b1fc",
  null
  
)

export default component.exports